export default __webpack_public_path__ + "static/media/Thug's Gloves of the Battlethrall.c54fac9e.jpg";